import { colors } from 'themes/index'

export const getRowColor = (idx: number): string => (idx % 2 === 0 ? colors.gray270 : 'transparent')
